const ModalTypes = {
  EDD_PINCODE: 'edd-pincode',
  EDD_MOVE_TO_CLOEST: 'edd-move-to-closet',
  // B2C seller list, opened from "Other sellers available" on the desktop PDP.
  B2C_SELLER_LIST: 'b2c-seller-list'
};

export default ModalTypes;
